"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-maria-imbaro": {
    "2c971488": [{
      "hkey": "d7480419",
      "slug": "perilli",
      "name": "Perilli",
      "primary": true,
      "skipSearch": false
    }],
    "borgate-perilli": [{
      "hkey": "d7480419",
      "slug": "perilli",
      "name": "Perilli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5e01fc01": [{
      "hkey": "32ed813e",
      "slug": "santa-maria-imbaro",
      "name": "Santa Maria Imbaro",
      "primary": true,
      "skipSearch": false
    }],
    "colli": [{
      "hkey": "32ed813e",
      "slug": "santa-maria-imbaro",
      "name": "Santa Maria Imbaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;